import React from "react";
import styles from "./FormInfoCard.module.scss";
import SvgWithBranding from "component/hoc/branding/withBrandingColor.hoc";

const FormInfoCard = ({ title, total, subTitle, icon }) => {
  return (
    <div className={styles["form-info-card"]}>
      <div className={styles["info-container"]}>
        <span className={styles["title"]}>{title}</span>
        <span className={styles["total"]}>{total}</span>
        <span className={styles["subTitle"]}>{subTitle}</span>
      </div>
      <div className={styles["icon-container"]}>
        <SvgWithBranding type={icon} onClick={() => {}} />
      </div>
    </div>
  );
};

export default FormInfoCard;
